// ============================================================================
// CHARGE TYPE ENDPOINTS
// ============================================================================
// crs.Api.Controllers.ChargeTypeModule.ChargeTypeController -> /api/v1/charge-types

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CHARGE_TYPE_BASE_PATH = '/charge-types';

export const chargeTypeEndpoints = {
  list: () => buildEndpoint(CHARGE_TYPE_BASE_PATH),
  lookup: () => buildEndpoint(`${CHARGE_TYPE_BASE_PATH}/lookup`),
  getById: (id: ID) => buildEndpointWithParams(`${CHARGE_TYPE_BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(CHARGE_TYPE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${CHARGE_TYPE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${CHARGE_TYPE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${CHARGE_TYPE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default chargeTypeEndpoints;
